export const PAYMENTS__SET_DATA = payload => {
    return {
        type: 'PAYMENTS__SET_DATA',
        payload,
    }
}
